import { countries, type Country } from './country-code-map';

// Re-export the Country type for external use
export type { Country };

// Helper function to get country code by country name (replaces getCountryAbbreviaion)
export const getCountryCodeByName = (countryName: string): string => {
  const country = countries.find(
    (c) => c.name.toLowerCase() === countryName.toLowerCase(),
  );
  return country?.value || 'US'; // Return uppercase code, default to US
};

export const getCountryData = () => {
  // Return default countries directly since context is not used
  return countries;
};
